import React from "react";
import { Table } from "react-bootstrap";
import {
  fetchActivitiesAdmin,
  editActivity,
  deleteActivity,
  createActivity,
} from "../../actions/activityActions";
import { connect } from "react-redux";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import NavbarClass from "../NavbarClass";
import { Form as ReactFinalForm, Field } from "react-final-form";
import _ from "lodash";
import { localAPI } from "../../api/local";
import { Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";

class AdminActivityPage extends React.Component {
  async componentDidMount() {
    await this.props.fetchActivitiesAdmin(this.props.handleSignInOpen);

    await localAPI
      .get("/api/users/isadmin")
      .then((data) => {
        if (!data.data.success) this.setState({ isAdmin: false });
      })
      .catch((err) => {
        this.setState({ isAdmin: false });
      });
  }

  state = {
    deleteModalShow: false,
    editAddModalShow: false,
    editModalShow: false,
    activityToDeleteEdit: {},
    isAdmin: true,
  };

  handleDeleteModalClose = () => {
    this.setState({ deleteModalShow: false, activityToDeleteEdit: {} });
  };
  handleDeleteModalShow = (activity) =>
    this.setState({ deleteModalShow: true, activityToDeleteEdit: activity });

  handleDeleteActivity = async (activityId) => {
    await this.props.deleteActivity(activityId, this.props.handleSignInOpen);
  };

  handleEditAddModalClose = () => {
    this.setState({ activityToDeleteEdit: {}, editAddModalShow: false });
  };

  handleEditAddModalShow = (activityRecieved) => {
    if (activityRecieved == {}) {
      this.setState({ editAddModalShow: true });
    } else
      this.setState({
        editAddModalShow: true,
        activityToDeleteEdit: activityRecieved,
      });
  };

  handleEditActivity = async (editedActivity) => {
    await this.props.editActivity(editedActivity, this.props.handleSignInOpen);
  };

  onEditModalSubmit = async (values) => {
    if (_.isEmpty(this.state.activityToDeleteEdit)) {
      await this.props.createActivity(values, this.props.handleSignInOpen);
    } else {
      await this.props.editActivity(values, this.props.handleSignInOpen);
    }
  };

  renderTable = () => {
    return this.props.activities.map((activity, key) => {
      return (
        <tr
          key={key + 1}
          style={
            activity.hideActivity
              ? { background: "rgba(128, 128, 128, 0.2)" }
              : {}
          }
        >
          <td>{key + 1}</td>
          <td>
            <img
              style={{ maxWidth: "100px" }}
              src={activity.thumbnailLink}
              alt={`thumbnail for ${activity.title}`}
              width="1200"
              height="700"
            />
          </td>
          <td>{activity.title}</td>
          <td>{activity.isFreeActivity ? "Yes" : "No"}</td>
          <td>som link</td>
          <td>{activity.category}</td>
          <td>
            {new Date(activity.uploadDateTime).toLocaleString("hi-IN", {
              dateStyle: "short",
              timeStyle: "short",
            })}
          </td>
          <td>
            <div
              className="btn btn-warning"
              onClick={() => this.handleEditAddModalShow(activity)}
            >
              Edit
            </div>
            <div
              className="btn btn-danger"
              onClick={() => this.handleDeleteModalShow(activity)}
            >
              Delete
            </div>
          </td>
        </tr>
      );
    });
  };
  //
  render() {
    return (
      <div>
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
        {this.props.activities ? (
          <div>
            <NavbarClass handleSignInOpen={this.props.handleSignInOpen} />
            <button
              className="btn btn-primary"
              onClick={() => this.handleEditAddModalShow({})}
            >
              {" "}
              Add Activity{" "}
            </button>

            <Modal
              show={this.state.deleteModalShow}
              onHide={this.handleDeleteModalClose}
              animation={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Delete Activity</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.state.activityToDeleteEdit ? (
                  <Table>
                    <tr>
                      <h1>Delete This Activity?</h1>
                    </tr>
                    <tbody>
                      <tr>
                        <th>Thumbnail</th>
                        <td>
                          <img
                            style={{ maxWidth: "100px" }}
                            src={this.state.activityToDeleteEdit.thumbnailLink}
                            alt={`thumbnail for ${this.state.activityToDeleteEdit.title}`}
                            width="1200"
                            height="700"
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>Title</th>
                        <td>{this.state.activityToDeleteEdit.title}</td>
                      </tr>
                      <tr>
                        <th>Free</th>
                        <td>
                          {this.state.activityToDeleteEdit.isFreeActivity
                            ? "Yes"
                            : "No"}
                        </td>
                      </tr>
                      <tr>
                        <th>Hidden</th>
                        <td>
                          {this.state.activityToDeleteEdit.hideActivity
                            ? "Yes"
                            : "No"}
                        </td>
                      </tr>
                      <tr>
                        <th>ActivityLink</th>
                        <td>som link</td>
                      </tr>
                      <tr>
                        <th>Upload Date</th>
                        <td>
                          {new Date(
                            this.state.activityToDeleteEdit.uploadDateTime
                          ).toLocaleString("hi-IN", {
                            dateStyle: "short",
                            timeStyle: "short",
                          })}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                ) : (
                  "No activity found"
                )}{" "}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={this.handleDeleteModalClose}
                >
                  Close
                </Button>
                <Button
                  variant="warning"
                  onClick={
                    this.state?.activityToDeleteEdit &&
                    (() =>
                      this.handleDeleteActivity(
                        this.state.activityToDeleteEdit._id
                      ))
                  }
                >
                  Delete
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal
              show={this.state.editAddModalShow}
              onHide={this.handleEditAddModalClose}
              animation={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Activities</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {
                  <div>
                    <ReactFinalForm
                      initialValues={
                        !(this.state.activityToDeleteEdit == {})
                          ? this.state.activityToDeleteEdit
                          : {}
                      }
                      onSubmit={this.onEditModalSubmit}
                      render={({
                        handleSubmit,
                        form,
                        submitting,
                        pristine,
                        values,
                      }) => {
                        return (
                          <form onSubmit={handleSubmit}>
                            {this.props.error && (
                              <Alert variant="danger">
                                <p>{this.props.error}</p>
                              </Alert>
                            )}
                            <Field name="title">
                              {({ input, meta }) => (
                                <div>
                                  <Form.Group className="mb-3">
                                    <Form.Label>Title</Form.Label>
                                    <Form.Control
                                      {...input}
                                      type="text"
                                      placeholder="Enter title"
                                      name="title"
                                      autofocus
                                    />
                                  </Form.Group>
                                </div>
                              )}
                            </Field>
                            <Field name="activityLink">
                              {({ input, meta }) => (
                                <div>
                                  <Form.Group className="mb-3">
                                    <Form.Label>Activity Link</Form.Label>
                                    <Form.Control
                                      {...input}
                                      type="text"
                                      placeholder="Activity Link"
                                      name="activityLink"
                                    />
                                  </Form.Group>
                                </div>
                              )}
                            </Field>
                            <Field name="thumbnailLink">
                              {({ input, meta }) => (
                                <div>
                                  <Form.Group className="mb-3">
                                    <Form.Label>Thumbnail Link</Form.Label>
                                    <Form.Control
                                      {...input}
                                      type="text"
                                      placeholder="Thumbnail Link"
                                      name="thumbnailLink"
                                    />
                                  </Form.Group>
                                </div>
                              )}
                            </Field>
                            <Field name="category">
                              {({ input, meta }) => (
                                <div>
                                  <Form.Group className="mb-3">
                                    <Form.Label>Category</Form.Label>
                                    <Form.Control
                                      {...input}
                                      type="text"
                                      placeholder="Category"
                                      name="category"
                                    />
                                  </Form.Group>
                                </div>
                              )}
                            </Field>
                            <Field name="isFreeActivity" type="checkbox">
                              {({ input, meta }) => (
                                <div>
                                  <label for="isFreeActivity">
                                    Free Activity
                                  </label>
                                  <input
                                    {...input}
                                    type="checkbox"
                                    id="isFreeActivity"
                                    name="isFreeActivity"
                                  />
                                </div>
                              )}
                            </Field>
                            <Field name="hideActivity" type="checkbox">
                              {({ input, meta }) => (
                                <div>
                                  <label for="hideActivity">
                                    Hide Activity
                                  </label>
                                  <input
                                    {...input}
                                    type="checkbox"
                                    id="hideActivity"
                                    name="hideActivity"
                                  />
                                </div>
                              )}
                            </Field>

                            <button
                              className="btn btn-warning"
                              style={{ marginTop: "15px" }}
                              type="submit"
                            >
                              submit
                            </button>
                          </form>
                        );
                      }}
                    />
                  </div>
                }{" "}
              </Modal.Body>
            </Modal>

            <Table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Thumbnail</th>
                  <th>Title</th>
                  <th>Free</th>
                  <th>ActivityLink</th>
                  <th>Category</th>

                  <th>Upload Date</th>
                  <th>Options</th>
                </tr>
                {this.props.activities ? this.renderTable() : "loading"}
              </thead>
            </Table>
          </div>
        ) : !this.state.isAdmin ? (
          <Redirect to="/" />
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    activities: state.activities.activities?.activities,
    loading: state.activities.loading,
    error: state.activities.error,
    // type: state.type,
  };
};

export default connect(mapStateToProps, {
  fetchActivitiesAdmin,
  editActivity,
  deleteActivity,
  createActivity,
})(AdminActivityPage);
